import React, { useEffect } from 'react';
import { getMerchantAppOrigin } from '@/utils/appConfig';

const MerchantOnboardingRedirect: React.FC<{ path?: string }> = ({ path = '/merchant/onboarding-choice' }) => {
  useEffect(() => {
    const suffix = path.startsWith('/') ? path : `/${path}`;
    window.location.replace(`${getMerchantAppOrigin()}${suffix}`);
  }, [path]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <p className="text-gray-600">Redirecting to merchant setup…</p>
    </div>
  );
};

export default MerchantOnboardingRedirect;
